module.exports = __webpack_public_path__ + "img/img_t_title_s.8188f5b1.png";